// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.qjxf25_VZ75NW3pYloq7 {
  border: 1px solid #333;
  border-radius: 10px;
  padding: 20px;
}
@media (max-width: 768px) {
  .qjxf25_VZ75NW3pYloq7 {
    padding: 10px;
    border: none;
  }
}

.vRksv3dIsQSGcCtOQIbh {
  border: none;
  border-radius: 0;
  padding: 36px 16px 16px;
}
@media (max-width: 768px) {
  .vRksv3dIsQSGcCtOQIbh {
    padding: 28px 10px 10px;
  }
}

.pRMpr3qIuhQb0MqGPNap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .pRMpr3qIuhQb0MqGPNap {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
}

.vSPu8BeW7XF3rm6Sdcdw {
  margin: 0;
}

.we5kLezQ3Qno7DLGnHFJ {
  color: #0669B3;
  display: flex;
  font-weight: 600;
  align-items: center;
  margin-left: auto;
}
@media (max-width: 768px) {
  .we5kLezQ3Qno7DLGnHFJ {
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
  }
}

.bYq18qnsMPPhAz_mQbY4 {
  border-radius: 5px;
  border: 1px solid #808080;
  padding: 2px 24px 2px 4px;
  font-size: 14px;
  margin-left: 8px;
}
@media (max-width: 768px) {
  .bYq18qnsMPPhAz_mQbY4 {
    flex: 1;
  }
}

.Or9R3KrW2ZQEr0ZK11nP {
  position: relative;
  display: flex;
  align-items: center;
}

.r0YXbOAwhefrylrpZVkc {
  position: absolute;
  right: 5px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.WuZoW7HNPjJTS5bS8pXT {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
}
@media (max-width: 768px) {
  .WuZoW7HNPjJTS5bS8pXT {
    padding: 10px;
  }
}

.ZN13t7v9PGjz3IGzTI98 .tooltip-inner {
  max-width: 400px;
  text-align: left;
}

.Ye4Doc0eVLYtvqeFBc9T {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 768px) {
  .Ye4Doc0eVLYtvqeFBc9T table,
  .Ye4Doc0eVLYtvqeFBc9T thead,
  .Ye4Doc0eVLYtvqeFBc9T tbody,
  .Ye4Doc0eVLYtvqeFBc9T th,
  .Ye4Doc0eVLYtvqeFBc9T td,
  .Ye4Doc0eVLYtvqeFBc9T tr {
    display: block;
  }
  .Ye4Doc0eVLYtvqeFBc9T thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .Ye4Doc0eVLYtvqeFBc9T tr {
    border: 1px solid #ccc;
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 8px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  .Ye4Doc0eVLYtvqeFBc9T td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding: 10px 8px !important;
    text-align: right !important;
    min-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
  }
  .Ye4Doc0eVLYtvqeFBc9T td:last-child {
    border-bottom: 0;
  }
  .Ye4Doc0eVLYtvqeFBc9T td:before {
    content: attr(data-label);
    font-weight: bold;
    text-align: left;
    flex: 1;
    font-size: 0.9rem;
    color: #555;
  }
  .Ye4Doc0eVLYtvqeFBc9T td > div, .Ye4Doc0eVLYtvqeFBc9T td > span, .Ye4Doc0eVLYtvqeFBc9T td > i {
    flex: 0 1 auto;
    justify-content: flex-end;
  }
}

.Ye4Doc0eVLYtvqeFBc9T td.kc0kltsKat1jtLxm5CtA {
  text-align: left;
  cursor: pointer;
  color: #0d6efd;
  text-decoration: underline;
}

.Ye4Doc0eVLYtvqeFBc9T td.ZFEVUGYSBA2l16Ilo1pq {
  text-align: left;
}

.dRwjPC5urihZp28RP83K {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #0d6efd;
  text-decoration: underline;
  font: inherit;
}

._07p6rOkWVgWPHu2yzGsA {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #0d6efd;
  text-decoration: underline;
  font: inherit;
  text-align: inherit;
  width: 100%;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/LocationTeacherOverview.module.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,sBAAA;EACA,mBAAA;EACA,aAAA;AAKJ;AAHI;EALJ;IAMQ,aAAA;IACA,YAAA;EAMN;AACF;;AAHA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;AAMJ;AAJI;EALJ;IAMQ,uBAAA;EAON;AACF;;AAJA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAOJ;AALI;EARJ;IASQ,sBAAA;IACA,uBAAA;IACA,WAAA;EAQN;AACF;;AALA;EACI,SAAA;AAQJ;;AALA;EACI,cDVS;ECWT,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAQJ;AANI;EAPJ;IAQQ,WAAA;IACA,cAAA;IACA,8BAAA;EASN;AACF;;AANA;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AASJ;AAPI;EAPJ;IAQQ,OAAA;EAUN;AACF;;AAPA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAUJ;AARI;EANJ;IAOQ,aAAA;EAWN;AACF;;AAPI;EACI,gBAAA;EACA,gBAAA;AAUR;;AANA;EACI,WAAA;EACA,gBAAA;EACA,iCAAA;AASJ;AAPI;EAEI;;;;;;IAMI,cAAA;EAQV;EALM;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAOV;EAJM;IACI,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;IACA,sBAAA;IACA,yCAAA;EAMV;EAHM;IACI,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,4BAAA;IACA,4BAAA;IACA,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,SAAA;EAKV;EAHU;IACI,gBAAA;EAKd;EAFU;IACI,yBAAA;IACA,iBAAA;IACA,gBAAA;IACA,OAAA;IACA,iBAAA;IACA,WAAA;EAId;EAAU;IAGI,cAAA;IACA,yBAAA;EAAd;AACF;;AAKA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,aAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAFJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.roundedBox {\n    border: 1px solid #333;\n    border-radius: 10px;\n    padding: 20px;\n\n    @media (max-width: 768px) {\n        padding: 10px;\n        border: none;\n    }\n}\n\n.embedded {\n    border: none;\n    border-radius: 0;\n    padding: 36px 16px 16px;\n\n    @media (max-width: 768px) {\n        padding: 28px 10px 10px;\n    }\n}\n\n.headerRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n\n    @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n    }\n}\n\n.schoolTitle {\n    margin: 0;\n}\n\n.lastNameFilterLabel {\n    color: $pearl-blue;\n    display: flex;\n    font-weight: 600;\n    align-items: center;\n    margin-left: auto;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        margin-left: 0;\n        justify-content: space-between;\n    }\n}\n\n.lastNameFilter {\n    border-radius: 5px;\n    border: 1px solid $grey3;\n    padding: 2px 24px 2px 4px;\n    font-size: 14px;\n    margin-left: 8px;\n\n    @media (max-width: 768px) {\n        flex: 1;\n    }\n}\n\n.inputWrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.clearButton {\n    position: absolute;\n    right: 5px;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.teacherGroup {\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 15px;\n\n    @media (max-width: 768px) {\n        padding: 10px;\n    }\n}\n\n.wideTooltip {\n    :global(.tooltip-inner) {\n        max-width: 400px;\n        text-align: left;\n    }\n}\n\n.responsiveTable {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n\n    @media (max-width: 768px) {\n\n        table,\n        thead,\n        tbody,\n        th,\n        td,\n        tr {\n            display: block;\n        }\n\n        thead tr {\n            position: absolute;\n            top: -9999px;\n            left: -9999px;\n        }\n\n        tr {\n            border: 1px solid #ccc;\n            margin-bottom: 16px;\n            border-radius: 8px;\n            padding: 8px;\n            background-color: #fff;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n        }\n\n        td {\n            border: none;\n            border-bottom: 1px solid #eee;\n            position: relative;\n            padding: 10px 8px !important;\n            text-align: right !important;\n            min-height: 40px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 15px;\n\n            &:last-child {\n                border-bottom: 0;\n            }\n\n            &:before {\n                content: attr(data-label);\n                font-weight: bold;\n                text-align: left;\n                flex: 1;\n                font-size: 0.9rem;\n                color: #555;\n            }\n\n            // Ensure the value container handles icons and text nicely\n            &>div,\n            &>span,\n            &>i {\n                flex: 0 1 auto;\n                justify-content: flex-end;\n            }\n        }\n    }\n}\n\n.responsiveTable td.teacherLinkCell {\n    text-align: left;\n    cursor: pointer;\n    color: #0d6efd;\n    text-decoration: underline;\n}\n\n.responsiveTable td.teacherNameCell {\n    text-align: left;\n}\n\n.setSlesButton {\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    color: #0d6efd;\n    text-decoration: underline;\n    font: inherit;\n}\n\n.teacherLinkButton {\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    color: #0d6efd;\n    text-decoration: underline;\n    font: inherit;\n    text-align: inherit;\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export var roundedBox = `qjxf25_VZ75NW3pYloq7`;
export var embedded = `vRksv3dIsQSGcCtOQIbh`;
export var headerRow = `pRMpr3qIuhQb0MqGPNap`;
export var schoolTitle = `vSPu8BeW7XF3rm6Sdcdw`;
export var lastNameFilterLabel = `we5kLezQ3Qno7DLGnHFJ`;
export var lastNameFilter = `bYq18qnsMPPhAz_mQbY4`;
export var inputWrapper = `Or9R3KrW2ZQEr0ZK11nP`;
export var clearButton = `r0YXbOAwhefrylrpZVkc`;
export var teacherGroup = `WuZoW7HNPjJTS5bS8pXT`;
export var wideTooltip = `ZN13t7v9PGjz3IGzTI98`;
export var responsiveTable = `Ye4Doc0eVLYtvqeFBc9T`;
export var teacherLinkCell = `kc0kltsKat1jtLxm5CtA`;
export var teacherNameCell = `ZFEVUGYSBA2l16Ilo1pq`;
export var setSlesButton = `dRwjPC5urihZp28RP83K`;
export var teacherLinkButton = `_07p6rOkWVgWPHu2yzGsA`;
export default ___CSS_LOADER_EXPORT___;
